import { ALL_SMS_LOGS } from "../../constant/ActionType";

export default function AllSmsLogsReducer(
    state = {
        allsmslogs: [],
        statusCode: null,
    },
    action
) {
    switch (action.type) {
        case ALL_SMS_LOGS:
            return {
                ...state,
                allsmslogs: action.data,
                statusCode: action.status,
            };

        default:
    }

    return state;
}
